/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum MuDataProcessingModelsEditSource {
    User = 'user',
    MuStreamEdit = 'mu_stream_edit'
}

export function MuDataProcessingModelsEditSourceFromJSON(json: any): MuDataProcessingModelsEditSource {
    return MuDataProcessingModelsEditSourceFromJSONTyped(json, false);
}

export function MuDataProcessingModelsEditSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingModelsEditSource {
    return json as MuDataProcessingModelsEditSource;
}

export function MuDataProcessingModelsEditSourceToJSON(value?: MuDataProcessingModelsEditSource | null): any {
    return value as any;
}

